function applyIubendaClasses() {
  const privacyElements = document.querySelectorAll(
    '.fui-field[data-field-handle="privacyPolicy"], .pp'
  );

  privacyElements.forEach((el) => {
    const link = el.querySelector("a");
    if (link) {
      link.classList.add(
        "iubenda-white",
        "iubenda-noiframe",
        "iubenda-embed",
        "iubenda-nostyle"
      );

      // Wait for Iubenda’s embed to apply its own inline style
      setTimeout(() => {
        link.style.width = "auto";
      }, 500); // 1s delay is enough
    }
  });
}

document.addEventListener("DOMContentLoaded", applyIubendaClasses);
document.addEventListener("formieRender", applyIubendaClasses);

/// Add lenis prevent on iubenda Iframe ////
// Wait for iubenda button to exist before attaching click listener (max 30s)
let iubendaRetries = 0;
const waitForIubendaButton = setInterval(() => {
  iubendaRetries++;
  if (iubendaRetries > 60) {
    clearInterval(waitForIubendaButton);
    return;
  }
  const iubendaBtn = document.querySelector(
    ".iubenda-tp-btn.iubenda-cs-preferences-link"
  );
  if (iubendaBtn) {
    clearInterval(waitForIubendaButton);
    iubendaBtn.addEventListener("click", () => {
      const observer = new MutationObserver((mutations, obs) => {
        const iframeDiv = document.getElementById("iubenda-iframe");
        if (iframeDiv) {
          iframeDiv.setAttribute("data-lenis-prevent", "");
          obs.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
}, 500);
